export const formatNumber = (number, point = 2) => {
  let total = typeof number === 'number' ? number : +number;
  const splitValue = total.toFixed(point).toString().split('.');
  if (splitValue[1]) {
    return `${splitValue[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')}.${splitValue[1]}`;
  } else {
    return total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
};

export const replaceZero = (number, isWuMaoAccount, precision = 2) => {
  if (number + '' == 'NaN') return '0';
  if (!number && number != 0) return '';
  if (isWuMaoAccount) {
    return number;
  }
  let newValue =
    typeof number == 'number'
      ? number.toFixed(precision)
      : (+(number + '').replace(/,/g, '')).toFixed(2);
  let [pres, scale] = newValue.split('.');
  (function () {
    while (/(\d+)[0\.]+$/g.test(scale)) {
      scale = scale.replace(/(\d+)[0\.]+$/g, '$1');
    }
  })();
  return pres + (scale && scale.length && scale > 0 ? `.${scale}` : '');
};

export const replaceLastZero = (number, isWuMaoAccount) => {
  if (number + '' == 'NaN') return '0';
  if (!number && number != 0) return '';
  if (isWuMaoAccount) {
    return number;
  }
  let newValue = typeof number == 'number' ? number + '' : number;
  let [pres, scale] = newValue.split('.');
  (function () {
    while (/(\d+)[0\.]+$/g.test(scale)) {
      scale = scale.replace(/(\d+)[0\.]+$/g, '$1');
    }
  })();
  return pres + (scale && scale.length && scale > 0 ? `.${scale}` : '');
};
